__turbopack_context__.v({
  "card": "WLatestRealizations-module__zHnfmW__card",
  "cardBadge": "WLatestRealizations-module__zHnfmW__cardBadge",
  "cardBody": "WLatestRealizations-module__zHnfmW__cardBody",
  "cardFooter": "WLatestRealizations-module__zHnfmW__cardFooter",
  "cardImg": "WLatestRealizations-module__zHnfmW__cardImg",
  "cardLink": "WLatestRealizations-module__zHnfmW__cardLink",
  "cardLogo": "WLatestRealizations-module__zHnfmW__cardLogo",
  "cardMedia": "WLatestRealizations-module__zHnfmW__cardMedia",
  "cardMore": "WLatestRealizations-module__zHnfmW__cardMore",
  "cardSector": "WLatestRealizations-module__zHnfmW__cardSector",
  "cardTitle": "WLatestRealizations-module__zHnfmW__cardTitle",
  "eyebrow": "WLatestRealizations-module__zHnfmW__eyebrow",
  "grid": "WLatestRealizations-module__zHnfmW__grid",
  "header": "WLatestRealizations-module__zHnfmW__header",
  "heading": "WLatestRealizations-module__zHnfmW__heading",
  "line": "WLatestRealizations-module__zHnfmW__line",
  "root": "WLatestRealizations-module__zHnfmW__root",
  "showAll": "WLatestRealizations-module__zHnfmW__showAll",
});
